export default "__VITE_ASSET__DNn5lq8N__"